import React, { useState } from "react";

export function useFormInput(id: string, initialValue: string) {
	const [value, setValue] = useState(initialValue);

	function handleChange(
		e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
	) {
		setValue(e.currentTarget.value);
	}

	return {
		id,
		name: id,
		onChange: handleChange,
		value,
	};
}
